import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "polotno.own_shapes";

export const useQueryPolotnoOwnShapes = (
  options?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpArtGallery.Polotno.shapes>>>,
    "queryKey" | "queryFn"
  >,
) => useQuery(KEY, ApiSmpArtGallery.Polotno.shapes, options);

useQueryPolotnoOwnShapes.KEY = KEY;
